import React, { useEffect, useRef, useState } from 'react';
import { Container, Row, Card, Col, Spinner, Form } from 'react-bootstrap';
import ResalesRequestService from '../../services/resales-request';
import DashboardRequestService from '../../services/dashboard-request';
import { DashboardOutlined } from '@material-ui/icons';
import { parseDateBR } from 'helpers/date.js';
import CardBanner from 'components/CardBanner';
import Chart from 'react-apexcharts';
import ChartParticipationIndex from './components/ChartParticipationIndex';
import CardFundScancash from 'components/CardFundDB/CardFundScancash';
import CardRanking from 'components/CardRanking';
import CardFundElitePass from 'components/CardFundDB/CardFundElitePass';
import DashboardRanking from './DashboardRanking';
import { AdminProfiles, FY24, FY25, FY23 } from 'helpers/Enum';

import { useCompany, useProfile } from 'models';

import * as logoElitePass from '../../images/logo/logo_elite_pass.png';
import * as logoScanSelect from '../../images/logo/logo_scansource_select_colorido.png';
import * as logoSS from '../../images/logo-sm.png';
import * as logoScancash from '../../images/scancash.png';
import * as logoElite from '../../images/logo-sm-elite.png';

import "./style.scss";
import { getNameByYear, useFiscalYearsList } from 'helpers';
import ChannelsDataRender from './components/ChannelsDataRender';
import TotalAccumulatedRevenueRender from './components/TotalAccumulatedRevenueRender';
import TotalMonthlyRevenueRender from './components/TotalMonthlyRevenueRender';

const HeadquarterView = ({ user }) => {
  const profile = useProfile();
  const company = useCompany()

  const fiscalYears = useFiscalYearsList()

  const [fiscalYear, setFiscalYear] = useState(() => {
    return fiscalYears[0];
  });

  const [fiscalYearObj, setFiscalYearObj] = useState(null);

  const [graphElite, setGraphElite] = useState([]);
  const [graphEliteManager, setGraphEliteManager] = useState([]);
  const [graphScancash, setGraphScancash] = useState([]);
  const [graphElitePass, setGraphElitePass] = useState([]);
  const [graphOthers, setGraphOthers] = useState([]);
  const [dashboardSelected, setDashboardSelected] = useState(-1);

  const ref_dashboard_1 = useRef();

  useEffect(() => {
    // FiscalYearRequestService.get(fiscalYear).then((data) => {
    //   setFiscalYearObj(data.data.data);
    // });
    // fundsTotalMarketing.hasLoad = false;
    // fundsTotalRebate.hasLoad = false;
    //getExpenses();
    //getRevenuesByMonth(0, setGraphOthers);
    //getRevenuesByMonth(1, setGraphElite);
    //getRevenuesByMonth(2, setGraphEliteManager);
    //getRevenuesByMonth(3, setGraphScancash);
    //getRevenuesByMonth(4, setGraphElitePass);
  }, [fiscalYear]);

  const getRevenuesByMonth = (premium, set) => {
    let filters = {
      premium: premium,
      sort_by: 'month',
      fiscal_year_id: fiscalYear,
    };

    ResalesRequestService
      .getCompanyByMonth({
        params: { ...filters }
      })
      .then((data) => {
        set(data.data);
      });
  };

  const getProps = () => {
    const minWidth = 440;
    const isMobile = window.innerWidth <= minWidth;

    let retorno = {};
    if (!isMobile) {
      retorno.width = 340;
    }

    return retorno;
  }

  return (
    <>
      {dashboardSelected == 1 ? (
        <DashboardRanking onBack={() => {
          setDashboardSelected(0);
        }} />
      ) : (
        <Container className={"mb-5" + (dashboardSelected === 0 ? " add-dashboard" : "")} ref={ref_dashboard_1}>
          <Row className="mt-4 justify-content-between">
            <Col md="12" className="d-flex align-items-center p-0">
              <div className="d-flex align-items-center">
                <DashboardOutlined className="icon-title" />
                <h5 className="title-dashboard">{getNameByYear(fiscalYear)} - </h5>
              </div>
              <div className="d-flex align-items-center">
                <Form.Control value={fiscalYear.id} size='sm' as="select" onChange={(e) => {
                  const fy = fiscalYears.filter(fy => fy.id == e.target.value)[0]
                  //localStorage.setItem("Elite:fiscalYear", JSON.stringify(fy))
                  setFiscalYear(fy)
                }}>
                  {fiscalYears.map((fy, idx) => (
                    <option value={fy.id} selected={idx == 0}>{fy.fiscal_year}</option>
                  ))}
                </Form.Control>
              </div>
            </Col>
            <Col md="auto" className="text-right float-right mt-1">
              {fiscalYear ? (
                <h6 className="dashboard-info">
                  Ano Fiscal:{' '}
                  <span className="span-light">
                    {parseDateBR(fiscalYear.start_period)}
                  </span>{' '}
                  -{' '}
                  <span className="span-light">
                    {parseDateBR(fiscalYear.end_period)}
                  </span>
                </h6>
              ) : (
                ''
              )}
            </Col>
          </Row>
          <CardRanking fiscalYear={fiscalYear} onOpenDashboard={() => {
            if (ref_dashboard_1 && ref_dashboard_1.current) {
              let element = ref_dashboard_1.current;
              element.classList.remove("add-dashboard")
              element.classList.add("remove-dashboard")
              setTimeout(() => {
                setDashboardSelected(1);
              }, 1000);
            }
          }} />
          <Row>
            <ChannelsDataRender fiscalYear={fiscalYear} />
            <ChartParticipationIndex {...{ chartProps: { ...getProps() }, fiscalYear }} />
          </Row>
          <CardBanner />
          <CardFundElitePass fiscalYear={fiscalYear}/>
          <Row>
            <Col className="p-1 pb-2" xl="5" lg="12" md="12">
              <TotalAccumulatedRevenueRender fiscalYear={fiscalYear}/>
            </Col>
            <Col className="p-1 pb-2" xl="7" lg="12" md="12">
              <TotalMonthlyRevenueRender fiscalYear={fiscalYear}/>
            </Col>
          </Row>
        </Container>
      )}
    </>
  );
};

export default HeadquarterView;
